var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circle-checkbox",class:{'checked': _vm.checked}},[_c('transition',{attrs:{"name":"zoom-fade"}},[(_vm.checked)?_c('icon-check'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }